import type { App } from 'vue'
import { tooltip } from '@eci-saas/ui'
import { permissionDirective } from './permission'

export default {
  install(app: App) {
    app.directive('tooltip', tooltip)
    app.directive('permission', permissionDirective)

    // 这里可以注册更多指令
  },
}
